import { GenericServices } from './generic.services';
import Uri from '../common/uri/session-uri.constants';

// VUE-156: one retry after a network-level failure; the endpoint is idempotent per X-App-SessionId.
const RETRY_DELAY_MS = 2000;

export class SessionServices extends GenericServices {
    // Never rejects: executeCreating resolves with the error; main.ts reports the Error left after the retry.
    async registerWebviewSession(): Promise<any> {
        const result = await this.executeCreating({}, Uri.webview);
        if (!(result instanceof Error)) return result;
        await new Promise(resolve => setTimeout(resolve, RETRY_DELAY_MS));
        return this.executeCreating({}, Uri.webview);
    }
}
